import { RouteScrubber } from '@framework/sentry/config';
import { stringHandler } from '@dealroadshow/data-scrubber-js/dist/handler/stringHandler';

const routeScrubber: RouteScrubber = [
  ['/login/investor/complete_profile/e/:entryCode', { entryCode: stringHandler }],
  ['/e/:entryCode/:slideNum?', { entryCode: stringHandler }],
  ['/login/investor/e/:entryCode', { entryCode: stringHandler }],
];

export default routeScrubber;
